export default "https://cdn-static.gokick.com/assets/c736ccdc0086f37925b8733f1854c980393ad61e/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";